import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import {
  provideBcfActivatedRoute,
  type BcfActivatedRoute
} from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import type { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs';
import type { ModalKindStandard } from './types';

export class ActivatedModal {
  constructor(private _activatedRoute: BcfActivatedRoute) {}

  public get modal$(): Observable<ModalKindStandard | undefined> {
    return this._activatedRoute.fragment.pipe(
      map((fragment: string | undefined) =>
        fragment?.includes('modal-') ? fragment.replace('modal-', '') : undefined
      ),
      map((modalNameWithParams: string | undefined) => modalNameWithParams?.split('$')[0] as ModalKindStandard),
      distinctUntilChanged()
    );
  }

  public get param(): Observable<string | undefined> {
    return this._activatedRoute.fragment.pipe(
      map((fragment: string | undefined) =>
        fragment?.startsWith('modal-') ? (fragment.split('$')?.[1] ?? undefined) : undefined
      ),
      distinctUntilChanged()
    );
  }

  public get params(): Observable<string[] | undefined> {
    return this.param.pipe(
      map((param: string | undefined) => param?.split('~')),
      distinctUntilChanged()
    );
  }
}

export function provideActivatedModal(): ActivatedModal {
  return provideSingleton(ActivatedModal, () => new ActivatedModal(provideBcfActivatedRoute()));
}
